<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.66276 4.00004V8.00004L11.3294 9.33337M15.3294 8.00004C15.3294 11.6819 12.3447 14.6667 8.66276 14.6667C4.98086 14.6667 1.99609 11.6819 1.99609 8.00004C1.99609 4.31814 4.98086 1.33337 8.66276 1.33337C12.3447 1.33337 15.3294 4.31814 15.3294 8.00004Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
